import { createFileRoute, Link } from "@tanstack/react-router";
import { buttonVariants, Skeleton } from "@rumbledirect/ui-v2";
import { getAffiliateId } from "@/auth/authStore";
import { RequirePermission } from "@/currentUser/RequirePermission";
import {
  getGetAdminServicePartnersServicePartnerIdQueryKey,
  useGetAdminServicePartnersServicePartnerId,
} from "@/lib/api/generated/service-partner/service-partner";
import {
  RepairerDetailPage,
  RepairerUnavailable,
} from "@/repairers/RepairerDetailPage";
import { parseRepairerSearch } from "@/repairers/repairersSearch";
import { useRepairerDetailLayout } from "@/repairers/useRepairerDetailLayout";

export const Route = createFileRoute(
  "/_authenticated/service-partners_/$servicePartnerId",
)({
  validateSearch: parseRepairerSearch,
  component: RepairerRoute,
});

function RepairerRoute() {
  return (
    <RequirePermission permission="admin_service_partner_read_details">
      <RepairerContent />
    </RequirePermission>
  );
}

function RepairerContent() {
  const { servicePartnerId } = Route.useParams();
  const search = Route.useSearch();
  const affiliateId = getAffiliateId();
  const config = useRepairerDetailLayout(servicePartnerId);
  const query = useGetAdminServicePartnersServicePartnerId(servicePartnerId, {
    query: {
      queryKey: [
        ...getGetAdminServicePartnersServicePartnerIdQueryKey(servicePartnerId),
        affiliateId,
      ],
    },
  });
  if (query.isError || config.isError)
    return (
      <div className="space-y-4">
        <Link
          to="/service-partners"
          search={search}
          className={buttonVariants({ variant: "ghost" })}
        >
          Terug naar herstellers
        </Link>
        <RepairerUnavailable
          onRetry={() => {
            if (query.isError) void query.refetch();
            if (config.isError) void config.refetch();
          }}
        />
      </div>
    );
  if (query.isPending || config.isPending)
    return (
      <div
        role="status"
        aria-live="polite"
        aria-label="Hersteller laden"
        className="space-y-6"
      >
        <span className="sr-only">Hersteller laden</span>
        <Skeleton className="h-16 w-80" />
        <Skeleton className="h-[32rem] w-full" />
      </div>
    );
  return (
    <RepairerDetailPage
      key={`${affiliateId}:${servicePartnerId}`}
      row={query.data}
      search={search}
      layout={config.data}
    />
  );
}
